import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';

import { CompliancePageListDueDiligenceComplianceRecordsQuery, DueDiligenceRecordStatus } from '@/__generated__/graphql';
import ActionDropdown from '@/components/basicComponents/actionDropdown';
import Tag from '@/components/basicComponents/tag';
import { TableColumns } from '@/components/table/types';
import { getUTCDate } from '@/shared/utils/date';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface DueDiligenceHistoryMobileTableProps {
  tableColumns: TableColumns[];
  tableRows: CompliancePageListDueDiligenceComplianceRecordsQuery['listDueDiligenceComplianceRecords']['records'];
  openPage: (path: string) => void;
}

const DueDiligenceHistoryMobileTable = ({ tableColumns, tableRows, openPage }: DueDiligenceHistoryMobileTableProps) => {
  const { t } = useTranslation(['enums']);

  const TableRow = ({ el }: { el: CompliancePageListDueDiligenceComplianceRecordsQuery['listDueDiligenceComplianceRecords']['records'][number] }) => {
    return (
      <MobileTableRowWrap key={el.id}>
        <MobileRow>
          <MobileRowTitle>{tableColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openPage(`/strategyDetails/${el?.investment?.id}?backToTitle=Compliance`)}>
            {el?.investment?.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[1].title}</MobileRowTitle>
          <MobileRowValue>
            {el?.investment?.subAssetClass
              ? `${el?.investment?.assetClass?.name} - ${el?.investment?.subAssetClass?.name}`
              : el?.investment?.assetClass?.name}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[2].title}</MobileRowTitle>
          <MobileRowValue>
            {el?.status && (
              <Tag styleType={el?.status === DueDiligenceRecordStatus.Approved ? 'valid' : 'warning'} size="md">
                {t(`enums:DueDiligenceRecordStatus.${el?.status}`) ?? ''}
              </Tag>
            )}
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[3].title}</MobileRowTitle>
          <MobileRowValue>{`${el?.activeTier?.funnel?.name} - ${el?.activeTier?.name}`}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[4].title}</MobileRowTitle>
          <MobileRowValue>{`${el?.approver?.firstName} ${el?.approver?.lastName}`}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{tableColumns[5].title}</MobileRowTitle>
          <MobileRowValue>{el?.statusUpdatedAt && getUTCDate(new Date(el.statusUpdatedAt))?.toUpperCase()}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <ActionDropdownWrapper>
            <ActionDropdown
              actionDropdownListPosition="center"
              options={[
                {
                  name: 'View Due Diligence',
                  onClick: () => openPage(`/compliance/dueDiligence/${el.id}?backToTitle=Due Diligence History`)
                }
              ]}
            />
          </ActionDropdownWrapper>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableRows.length ? (
        tableRows.map((el) => {
          // eslint-disable-next-line react/prop-types
          return <TableRow el={el} key={el.id} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default DueDiligenceHistoryMobileTable;

const ActionDropdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
